
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("67bV2", function(module, exports) {

$parcel$export(module.exports, "MAX_DATA_ENTRIES", () => $473ca46871bf4e5e$export$e4044ce0e34b99b8);
$parcel$export(module.exports, "state", () => $473ca46871bf4e5e$export$ca000e230c0caa3e);
$parcel$export(module.exports, "normalizeJobID", () => $473ca46871bf4e5e$export$e3d3ada130c69581);
$parcel$export(module.exports, "isValidJobID", () => $473ca46871bf4e5e$export$b199f3c5886086b8);
$parcel$export(module.exports, "canShowBioAgentsNav", () => $473ca46871bf4e5e$export$76ab23134b37abc3);
$parcel$export(module.exports, "DATASET_PREVIEW_MAX_BYTES", () => $473ca46871bf4e5e$export$419257b8c73cd22f);
$parcel$export(module.exports, "getDatasetPreviewKind", () => $473ca46871bf4e5e$export$c76cd029882a89a2);
$parcel$export(module.exports, "setViewAsEmail", () => $473ca46871bf4e5e$export$6eccb672ab059c19);
$parcel$export(module.exports, "updateUserDisplay", () => $473ca46871bf4e5e$export$271c842b6543f4fb);
$parcel$export(module.exports, "loadSavedViewAs", () => $473ca46871bf4e5e$export$b9eaf2e25638fa94);
$parcel$export(module.exports, "impersonationQuery", () => $473ca46871bf4e5e$export$ddd8b7e0d171d50f);
$parcel$export(module.exports, "runPageCleanup", () => $473ca46871bf4e5e$export$82f81f7fa10c04aa);
$parcel$export(module.exports, "setPageCleanup", () => $473ca46871bf4e5e$export$44b20cbaaca06c48);
$parcel$export(module.exports, "startPagePoller", () => $473ca46871bf4e5e$export$63b9f654b3afc533);
$parcel$export(module.exports, "getLoginFlag", () => $473ca46871bf4e5e$export$95bf15017b4c24de);
$parcel$export(module.exports, "getid", () => $473ca46871bf4e5e$export$be0a47e74a8e269f);
$parcel$export(module.exports, "isActiveTeamAdmin", () => $473ca46871bf4e5e$export$93856622fbb418c);
$parcel$export(module.exports, "setTeams", () => $473ca46871bf4e5e$export$f5f5b17399e212fc);
$parcel$export(module.exports, "setActiveTeamId", () => $473ca46871bf4e5e$export$21a0f2f28bf0f9d);
$parcel$export(module.exports, "hydrateProjectFocus", () => $473ca46871bf4e5e$export$372ad420fa186f77);
$parcel$export(module.exports, "getActiveProjectFocus", () => $473ca46871bf4e5e$export$32ea3ebab1ce388c);
$parcel$export(module.exports, "setActiveProjectFocus", () => $473ca46871bf4e5e$export$e0951880a696f1b0);
$parcel$export(module.exports, "clearActiveProjectFocus", () => $473ca46871bf4e5e$export$6881dee851c0196d);
$parcel$export(module.exports, "resetPage", () => $473ca46871bf4e5e$export$e6af8dd0b73b20c2);
$parcel$export(module.exports, "setLoginFlag", () => $473ca46871bf4e5e$export$d0bd1b4ae9390466);
$parcel$export(module.exports, "setCredits", () => $473ca46871bf4e5e$export$69422b0fbbaf40bd);
$parcel$export(module.exports, "clearClientAuthState", () => $473ca46871bf4e5e$export$2d80366d699d0376);
$parcel$export(module.exports, "formatDateTime", () => $473ca46871bf4e5e$export$8b492ed8828f789c);
// DOM Elements
const $473ca46871bf4e5e$export$e4044ce0e34b99b8 = 20;
const $473ca46871bf4e5e$var$JOB_ID_REGEX = /^(?:job-[a-f0-9]{8}-[a-f0-9]{8}|[a-f0-9]{16})$/;
const $473ca46871bf4e5e$var$VIEW_AS_STORAGE_KEY = 'ssq_view_as';
const $473ca46871bf4e5e$var$ACTIVE_TEAM_STORAGE_KEY = 'ssq_active_team_id';
const $473ca46871bf4e5e$var$PROJECT_FOCUS_STORAGE_KEY = 'ssq_project_focus_by_scope';
function $473ca46871bf4e5e$var$readSavedTeamID() {
    try {
        const raw = localStorage.getItem($473ca46871bf4e5e$var$ACTIVE_TEAM_STORAGE_KEY);
        const id = parseInt(raw || '0', 10);
        return Number.isFinite(id) && id > 0 ? id : 0;
    } catch  {
        return 0;
    }
}
function $473ca46871bf4e5e$var$readProjectFocusMap() {
    try {
        const raw = localStorage.getItem($473ca46871bf4e5e$var$PROJECT_FOCUS_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch  {
        return {};
    }
}
function $473ca46871bf4e5e$var$writeProjectFocusMap(map) {
    try {
        localStorage.setItem($473ca46871bf4e5e$var$PROJECT_FOCUS_STORAGE_KEY, JSON.stringify(map || {}));
    } catch  {}
}
function $473ca46871bf4e5e$var$projectFocusScopeKey(teamID = 0, email = '') {
    const team = Number(teamID || 0);
    if (Number.isFinite(team) && team > 0) return `team:${team}`;
    const cleanEmail = String(email || '').trim().toLowerCase();
    return cleanEmail ? `user:${cleanEmail}` : 'personal';
}
function $473ca46871bf4e5e$var$readSavedProjectFocusForScope() {
    const map = $473ca46871bf4e5e$var$readProjectFocusMap();
    const key = $473ca46871bf4e5e$var$projectFocusScopeKey($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId, $473ca46871bf4e5e$export$ca000e230c0caa3e.email);
    const value = String(map[key] || '').trim();
    return value;
}
function $473ca46871bf4e5e$export$e3d3ada130c69581(value) {
    return String(value || '').trim().toLowerCase();
}
function $473ca46871bf4e5e$export$b199f3c5886086b8(value) {
    if (!value) return false;
    return $473ca46871bf4e5e$var$JOB_ID_REGEX.test($473ca46871bf4e5e$export$e3d3ada130c69581(value));
}
function $473ca46871bf4e5e$export$76ab23134b37abc3() {
    return !!$473ca46871bf4e5e$export$ca000e230c0caa3e.isOwner && !$473ca46871bf4e5e$export$ca000e230c0caa3e.viewAsEmail;
}
const $473ca46871bf4e5e$var$extSet = (value)=>new Set(String(value).trim().split(/\s+/).filter(Boolean));
const $473ca46871bf4e5e$export$29b2633ebe0d0484 = $473ca46871bf4e5e$var$extSet('.txt .index .dbtype .log .json .csv .py .pyw .pl .pm .sh .bash .r .md .fasta .trb .fa .fas .fsa .faa .fna .ffn .frn .mfa .mpfa .afa .a3m .pep .seq .hhr .gb .dna .xml .html .fq .fastq .gbk .embl .gff .gff3 .gtf .bed .bedgraph .wig .vcf .sam .pileup .mpileup .psl .aln .clustal .sto .phy .msf .nwk .tree .tre .nex .nexus .cellml .owl .gmt .obo .mitab .tsv .jsonl .yml .yaml .toml .ini .pkl .mdp .top .itp .ndx');
const $473ca46871bf4e5e$export$c694742053ac23ba = $473ca46871bf4e5e$var$extSet('.png .jpg .jpeg .gif .bmp .svg .webp .tif .tiff .heic .heif');
const $473ca46871bf4e5e$export$56dc9b6fc7b27fd7 = $473ca46871bf4e5e$var$extSet('.mp4 .webm');
const $473ca46871bf4e5e$export$1e4faece8b5bdb4f = $473ca46871bf4e5e$var$extSet('.pdb .ent .brk .cif .mmcif .mmtf .gro .g96 .sdf .mol .mol2 .pdbqt .xyz .pqr .psf .xtc .trr .dcd');
const $473ca46871bf4e5e$export$38595e6000dbab1 = $473ca46871bf4e5e$var$extSet('.npz');
const $473ca46871bf4e5e$export$419257b8c73cd22f = 2097152; // front-end guard to avoid huge previews
function $473ca46871bf4e5e$var$stripCompressionSuffix(p) {
    if (!p) return '';
    return String(p).toLowerCase().replace(/\.(?:gz|gzip|bz2|xz|zip)$/g, '');
}
function $473ca46871bf4e5e$export$c76cd029882a89a2(path) {
    if (!path) return null;
    const lower = $473ca46871bf4e5e$var$stripCompressionSuffix(String(path));
    if (!lower) return null;
    for (const ext of $473ca46871bf4e5e$export$56dc9b6fc7b27fd7){
        if (lower.endsWith(ext)) return 'video';
    }
    for (const ext of $473ca46871bf4e5e$export$c694742053ac23ba){
        if (lower.endsWith(ext)) return 'image';
    }
    for (const ext of $473ca46871bf4e5e$export$1e4faece8b5bdb4f){
        if (lower.endsWith(ext)) return 'structure';
    }
    for (const ext of $473ca46871bf4e5e$export$38595e6000dbab1){
        if (lower.endsWith(ext)) return 'npz';
    }
    for (const ext of $473ca46871bf4e5e$export$29b2633ebe0d0484){
        if (lower.endsWith(ext)) return 'text';
    }
    return null;
}
const $473ca46871bf4e5e$export$ca000e230c0caa3e = {
    email: '',
    tempEmail: '',
    success: false,
    error: '',
    data: {},
    redUrl: '',
    totalJobs: 0,
    jobFilter: 'all',
    jobProgramFilter: '',
    jobPipelineFilter: '',
    jobs: [],
    job_id: '',
    jobinfo: null,
    jobsLoading: false,
    jobCanceling: false,
    jobInfoLoading: false,
    totalTxs: 0,
    txFilter: 'all',
    txs: [],
    txsLoading: false,
    // Projects
    projects: [],
    activeProjectFocus: '',
    teams: [],
    activeTeamId: $473ca46871bf4e5e$var$readSavedTeamID(),
    activeTeamName: '',
    // Analytics access (special-case owner)
    analyticsAccess: false,
    // Owner-only hidden impersonation
    isOwner: false,
    viewAsEmail: '',
    api_wait_ms: 180
};
function $473ca46871bf4e5e$export$6eccb672ab059c19(email) {
    const clean = String(email || '').trim().toLowerCase();
    $473ca46871bf4e5e$export$ca000e230c0caa3e.viewAsEmail = clean;
    try {
        if ($473ca46871bf4e5e$export$ca000e230c0caa3e.isOwner && clean) sessionStorage.setItem($473ca46871bf4e5e$var$VIEW_AS_STORAGE_KEY, clean);
        else sessionStorage.removeItem($473ca46871bf4e5e$var$VIEW_AS_STORAGE_KEY);
    } catch (_) {}
    try {
        localStorage.removeItem($473ca46871bf4e5e$var$VIEW_AS_STORAGE_KEY);
    } catch (_) {}
    try {
        $473ca46871bf4e5e$export$271c842b6543f4fb();
    } catch  {}
}
function $473ca46871bf4e5e$export$b9eaf2e25638fa94() {
    try {
        const saved = sessionStorage.getItem($473ca46871bf4e5e$var$VIEW_AS_STORAGE_KEY) || '';
        $473ca46871bf4e5e$export$ca000e230c0caa3e.viewAsEmail = $473ca46871bf4e5e$export$ca000e230c0caa3e.isOwner ? String(saved || '').trim().toLowerCase() : '';
    } catch (_) {
        $473ca46871bf4e5e$export$ca000e230c0caa3e.viewAsEmail = '';
    }
    try {
        localStorage.removeItem($473ca46871bf4e5e$var$VIEW_AS_STORAGE_KEY);
    } catch (_) {}
}
function $473ca46871bf4e5e$export$ddd8b7e0d171d50f() {
    const params = [];
    if ($473ca46871bf4e5e$export$ca000e230c0caa3e.isOwner && $473ca46871bf4e5e$export$ca000e230c0caa3e.viewAsEmail) params.push(`user_email=${encodeURIComponent($473ca46871bf4e5e$export$ca000e230c0caa3e.viewAsEmail)}`);
    if ($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId) params.push(`team_id=${encodeURIComponent(String($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId))}`);
    return params.join('&');
}
// Page-level cleanup + lightweight polling helpers (cleared on route change)
let $473ca46871bf4e5e$var$currentPageCleanup = null;
function $473ca46871bf4e5e$export$82f81f7fa10c04aa() {
    const fn = $473ca46871bf4e5e$var$currentPageCleanup || (typeof window !== 'undefined' ? window.__pageCleanup : null);
    $473ca46871bf4e5e$var$currentPageCleanup = null;
    if (typeof window !== 'undefined') window.__pageCleanup = null;
    if (typeof fn === 'function') try {
        fn();
    } catch (err) {
        console.warn('page cleanup failed', err);
    }
}
function $473ca46871bf4e5e$export$44b20cbaaca06c48(fn) {
    $473ca46871bf4e5e$var$currentPageCleanup = typeof fn === 'function' ? fn : null;
    if (typeof window !== 'undefined') window.__pageCleanup = $473ca46871bf4e5e$var$currentPageCleanup;
}
function $473ca46871bf4e5e$export$63b9f654b3afc533(task, intervalMs = 60000, { runImmediately: runImmediately = false } = {}) {
    if (typeof task !== 'function' || !Number.isFinite(intervalMs) || intervalMs <= 0) return ()=>{};
    let stopped = false;
    let running = false;
    const tick = async ()=>{
        if (stopped || running) return;
        if (typeof document !== 'undefined' && document.hidden) return;
        running = true;
        try {
            await task();
        } catch (err) {
            console.error('poll task failed', err);
        } finally{
            running = false;
        }
    };
    if (runImmediately) tick();
    const timer = setInterval(tick, intervalMs);
    return ()=>{
        stopped = true;
        clearInterval(timer);
    };
}
function $473ca46871bf4e5e$export$271c842b6543f4fb() {
    const loggedIn = !!$473ca46871bf4e5e$export$95bf15017b4c24de();
    const safeToggle = (id, hidden)=>{
        const el = $473ca46871bf4e5e$export$be0a47e74a8e269f(id);
        if (el && el.classList) el.classList.toggle('hidden', hidden);
    };
    safeToggle('loginButton', loggedIn);
    safeToggle('acct-info', !loggedIn);
    try {
        document.body.classList.toggle('logged-in', loggedIn);
    } catch  {}
    // Show or hide navigation buttons based on login state
    safeToggle('projects_btn', !loggedIn);
    safeToggle('datasets_btn', !loggedIn);
    safeToggle('new_job_btn', !loggedIn);
    safeToggle('view_jobs_btn', !loggedIn);
    safeToggle('pipelines_btn', !loggedIn);
    safeToggle('templates_btn', !loggedIn);
    safeToggle('bio_agents_btn', !loggedIn || !$473ca46871bf4e5e$export$76ab23134b37abc3());
    safeToggle('registry_btn', !loggedIn || !$473ca46871bf4e5e$export$76ab23134b37abc3());
    safeToggle('workshop_btn', !loggedIn || !$473ca46871bf4e5e$export$76ab23134b37abc3());
    const focusedProject = loggedIn ? String($473ca46871bf4e5e$export$ca000e230c0caa3e.activeProjectFocus || '').trim() : '';
    const projectsBtn = $473ca46871bf4e5e$export$be0a47e74a8e269f('projects_btn');
    if (projectsBtn) {
        const labelEl = projectsBtn.querySelector('.nav-label');
        if (labelEl) labelEl.textContent = 'Projects';
        projectsBtn.setAttribute('aria-label', 'Projects');
        projectsBtn.title = 'Projects';
        projectsBtn.onclick = (event)=>{
            if (event && typeof event.preventDefault === 'function') event.preventDefault();
            if (typeof window.navigate === 'function') window.navigate('/projects');
            else window.location.href = '/projects';
        };
    }
    const focusNav = $473ca46871bf4e5e$export$be0a47e74a8e269f('projectFocusNav');
    const focusName = $473ca46871bf4e5e$export$be0a47e74a8e269f('projectFocusName');
    const focusClear = $473ca46871bf4e5e$export$be0a47e74a8e269f('projectFocusClear');
    if (focusNav) {
        focusNav.classList.toggle('hidden', !focusedProject);
        focusNav.title = focusedProject ? `Focused project: ${focusedProject}` : '';
    }
    if (focusName) {
        focusName.textContent = focusedProject;
        focusName.title = focusedProject;
    }
    if (focusClear) {
        focusClear.title = focusedProject ? `Clear project focus: ${focusedProject}` : 'Clear project focus';
        focusClear.setAttribute('aria-label', focusedProject ? `Clear project focus: ${focusedProject}` : 'Clear project focus');
    }
    if (loggedIn) {
        const emailEl = $473ca46871bf4e5e$export$be0a47e74a8e269f('email-disp');
        const creditsEl = $473ca46871bf4e5e$export$be0a47e74a8e269f('credits-disp');
        const teamEl = $473ca46871bf4e5e$export$be0a47e74a8e269f('activeTeamDisplay');
        const impersonating = $473ca46871bf4e5e$export$ca000e230c0caa3e.isOwner && !!$473ca46871bf4e5e$export$ca000e230c0caa3e.viewAsEmail;
        if (teamEl) {
            const teamActive = !!$473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId;
            teamEl.textContent = teamActive ? $473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamName || `Team ${$473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId}` : '';
            teamEl.title = teamActive ? `Active team: ${teamEl.textContent}` : '';
            teamEl.classList.toggle('hidden', !teamActive);
        }
        if (emailEl) {
            emailEl.textContent = $473ca46871bf4e5e$export$ca000e230c0caa3e.email || '';
            emailEl.classList.toggle('impersonating', impersonating);
            emailEl.title = $473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamName ? `Team scope: ${$473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamName}` : impersonating ? 'Impersonating account' : '';
        }
        safeToggle('accountTxsBtn', !!$473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId);
        safeToggle('accountKeysBtn', !!$473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId);
        safeToggle('accountTeamsBtn', !!$473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId);
        if (creditsEl) {
            const teamReadonly = !!$473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId && !$473ca46871bf4e5e$export$93856622fbb418c();
            creditsEl.textContent = `$${$473ca46871bf4e5e$export$5d582863dbe0f2f5().toFixed(2)}`;
            creditsEl.classList.toggle('readonly', teamReadonly);
            creditsEl.title = teamReadonly ? 'Only team admins can add team credits.' : '';
            if (teamReadonly) $473ca46871bf4e5e$export$be0a47e74a8e269f('creditsInputContainer')?.classList.add('hidden');
        }
    }
    // Impersonation is indicated on the account button itself.
    const badge = $473ca46871bf4e5e$export$be0a47e74a8e269f('impersonationBadge');
    const badgeText = $473ca46871bf4e5e$export$be0a47e74a8e269f('impersonationText');
    if (badge && badge.classList) badge.classList.add('hidden');
    if (badgeText) badgeText.textContent = 'DEV MODE';
    // Recompute header layout after DOM changes (mobile: one-row vs two-rows)
    try {
        if (typeof window.updateHeaderLayout === 'function') // Defer to next frame so measurements reflect new content
        requestAnimationFrame(()=>window.updateHeaderLayout());
    } catch  {}
    try {
        document.dispatchEvent(new CustomEvent('ssq-user-display-changed', {
            detail: {
                loggedIn: loggedIn
            }
        }));
    } catch  {}
}
function $473ca46871bf4e5e$export$f5f5b17399e212fc(teams) {
    $473ca46871bf4e5e$export$ca000e230c0caa3e.teams = Array.isArray(teams) ? teams : [];
    const active = $473ca46871bf4e5e$export$ca000e230c0caa3e.teams.find((t)=>Number(t.team_id || 0) === Number($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId || 0));
    if ($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId && !active) {
        $473ca46871bf4e5e$export$21a0f2f28bf0f9d(0);
        return;
    }
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamName = active ? String(active.name || '') : '';
    $473ca46871bf4e5e$export$271c842b6543f4fb();
}
function $473ca46871bf4e5e$export$21a0f2f28bf0f9d(teamID) {
    const id = Number(teamID || 0);
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId = Number.isFinite(id) && id > 0 ? id : 0;
    const active = $473ca46871bf4e5e$export$ca000e230c0caa3e.teams.find((t)=>Number(t.team_id || 0) === $473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId);
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamName = active ? String(active.name || '') : '';
    try {
        if ($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId) localStorage.setItem($473ca46871bf4e5e$var$ACTIVE_TEAM_STORAGE_KEY, String($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId));
        else localStorage.removeItem($473ca46871bf4e5e$var$ACTIVE_TEAM_STORAGE_KEY);
    } catch  {}
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeProjectFocus = $473ca46871bf4e5e$var$readSavedProjectFocusForScope();
    $473ca46871bf4e5e$export$271c842b6543f4fb();
}
function $473ca46871bf4e5e$export$372ad420fa186f77() {
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeProjectFocus = $473ca46871bf4e5e$var$readSavedProjectFocusForScope();
    $473ca46871bf4e5e$export$271c842b6543f4fb();
    return $473ca46871bf4e5e$export$ca000e230c0caa3e.activeProjectFocus;
}
function $473ca46871bf4e5e$export$32ea3ebab1ce388c() {
    return String($473ca46871bf4e5e$export$ca000e230c0caa3e.activeProjectFocus || '').trim();
}
function $473ca46871bf4e5e$export$e0951880a696f1b0(project) {
    const clean = String(project || '').trim();
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeProjectFocus = clean;
    const key = $473ca46871bf4e5e$var$projectFocusScopeKey($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId, $473ca46871bf4e5e$export$ca000e230c0caa3e.email);
    const map = $473ca46871bf4e5e$var$readProjectFocusMap();
    if (clean) map[key] = clean;
    else delete map[key];
    $473ca46871bf4e5e$var$writeProjectFocusMap(map);
    $473ca46871bf4e5e$export$271c842b6543f4fb();
    try {
        document.dispatchEvent(new CustomEvent('ssq-project-focus-changed', {
            detail: {
                project: clean
            }
        }));
    } catch  {}
    return clean;
}
function $473ca46871bf4e5e$export$6881dee851c0196d() {
    return $473ca46871bf4e5e$export$e0951880a696f1b0('');
}
function $473ca46871bf4e5e$export$93856622fbb418c() {
    if (!$473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId) return true;
    const active = $473ca46871bf4e5e$export$ca000e230c0caa3e.teams.find((t)=>Number(t.team_id || 0) === Number($473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId || 0));
    return !!active?.is_team_admin;
}
function $473ca46871bf4e5e$export$be0a47e74a8e269f(id) {
    return document.getElementById(id);
}
function $473ca46871bf4e5e$export$e6af8dd0b73b20c2() {
    const url = `${window.location.pathname}${window.location.search}`;
    window.history.replaceState({}, document.title, url);
    window.location.reload();
}
function $473ca46871bf4e5e$export$d0bd1b4ae9390466(isLoggedIn, expiry) {
    if (isLoggedIn) localStorage.setItem('loginFlag', expiry);
    else localStorage.removeItem('loginFlag');
}
function $473ca46871bf4e5e$export$95bf15017b4c24de() {
    const expiry = parseInt(localStorage.getItem('loginFlag'), 10);
    if (!expiry || Math.floor(Date.now() / 1000) > expiry) {
        localStorage.removeItem('loginFlag');
        return false;
    }
    return expiry;
}
function $473ca46871bf4e5e$export$69422b0fbbaf40bd(credits) {
    localStorage.setItem('credits', credits.toFixed(2));
}
function $473ca46871bf4e5e$export$5d582863dbe0f2f5() {
    return parseFloat(localStorage.getItem('credits')) || 0;
}
function $473ca46871bf4e5e$export$2d80366d699d0376() {
    $473ca46871bf4e5e$export$ca000e230c0caa3e.email = '';
    $473ca46871bf4e5e$export$ca000e230c0caa3e.tempEmail = '';
    $473ca46871bf4e5e$export$ca000e230c0caa3e.analyticsAccess = false;
    $473ca46871bf4e5e$export$ca000e230c0caa3e.isOwner = false;
    $473ca46871bf4e5e$export$ca000e230c0caa3e.viewAsEmail = '';
    $473ca46871bf4e5e$export$ca000e230c0caa3e.teams = [];
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamId = 0;
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeTeamName = '';
    $473ca46871bf4e5e$export$ca000e230c0caa3e.activeProjectFocus = '';
    try {
        localStorage.removeItem('loginFlag');
    } catch  {}
    try {
        localStorage.removeItem('credits');
    } catch  {}
    try {
        localStorage.removeItem($473ca46871bf4e5e$var$ACTIVE_TEAM_STORAGE_KEY);
    } catch  {}
    try {
        sessionStorage.removeItem($473ca46871bf4e5e$var$VIEW_AS_STORAGE_KEY);
    } catch  {}
    try {
        localStorage.removeItem($473ca46871bf4e5e$var$VIEW_AS_STORAGE_KEY);
    } catch  {}
    try {
        delete window.subseqSetViewAs;
    } catch  {}
    $473ca46871bf4e5e$export$271c842b6543f4fb();
}
function $473ca46871bf4e5e$export$8b492ed8828f789c(ts) {
    if (ts === null || ts === undefined || ts === '') return '';
    try {
        let d;
        if (typeof ts === 'number') // Heuristic: treat < 1e11 as seconds, otherwise ms
        d = new Date(ts < 1e11 ? ts * 1000 : ts);
        else if (typeof ts === 'string') {
            // Numeric strings → parse similarly to numbers
            const num = Number(ts);
            if (!Number.isNaN(num) && ts.trim() !== '') d = new Date(num < 1e11 ? num * 1000 : num);
            else d = new Date(ts);
        } else if (ts instanceof Date) d = ts;
        else return '';
        if (Number.isNaN(d.getTime())) return '';
        const pad = (n)=>String(n).padStart(2, '0');
        const yyyy = d.getFullYear();
        const mm = pad(d.getMonth() + 1);
        const dd = pad(d.getDate());
        const HH = pad(d.getHours());
        const MM = pad(d.getMinutes());
        return `${yyyy}-${mm}-${dd} ${HH}:${MM}`;
    } catch  {
        return '';
    }
}

});

parcelRegister("9MHdv", function(module, exports) {

$parcel$export(module.exports, "withImpersonation", () => $71fa1eb46d6f32a2$export$230adb16b95ac815);
$parcel$export(module.exports, "getDatasetInfo", () => $71fa1eb46d6f32a2$export$3669e5bb98eb74e3);
$parcel$export(module.exports, "getDatasetInfoByName", () => $71fa1eb46d6f32a2$export$bcba7e442bab9817);
$parcel$export(module.exports, "getProjectPrimaryDataset", () => $71fa1eb46d6f32a2$export$36024048467da74c);
$parcel$export(module.exports, "fetchDatasetFile", () => $71fa1eb46d6f32a2$export$a4e344481ab5adfd);
$parcel$export(module.exports, "getJobInfo", () => $71fa1eb46d6f32a2$export$f11896f9fbfa2c1e);
$parcel$export(module.exports, "getJobResults", () => $71fa1eb46d6f32a2$export$5dafc8d63fc6f4f0);
$parcel$export(module.exports, "fetchJobFile", () => $71fa1eb46d6f32a2$export$9adb42d7c69aad44);
$parcel$export(module.exports, "getDatasetResults", () => $71fa1eb46d6f32a2$export$2ae73e3d443a8aaa);
$parcel$export(module.exports, "reqOTP", () => $71fa1eb46d6f32a2$export$9ad920565113bbfa);
$parcel$export(module.exports, "verifyPayment", () => $71fa1eb46d6f32a2$export$dcd88816af569b61);
$parcel$export(module.exports, "login", () => $71fa1eb46d6f32a2$export$596d806903d1f59e);
$parcel$export(module.exports, "logout", () => $71fa1eb46d6f32a2$export$a0973bcfe11b05c9);
$parcel$export(module.exports, "loadUserInfo", () => $71fa1eb46d6f32a2$export$20eb8298185fc87b);
$parcel$export(module.exports, "loadTeams", () => $71fa1eb46d6f32a2$export$79e2c9b6a8cec01c);
$parcel$export(module.exports, "createTeam", () => $71fa1eb46d6f32a2$export$dadd67f86cf9b534);
$parcel$export(module.exports, "getTeamInfo", () => $71fa1eb46d6f32a2$export$ded43b9f71d30fcf);
$parcel$export(module.exports, "renameTeam", () => $71fa1eb46d6f32a2$export$1bf59bff292a469d);
$parcel$export(module.exports, "addTeamMember", () => $71fa1eb46d6f32a2$export$1d57c8a8fd4b49d1);
$parcel$export(module.exports, "updateTeamMember", () => $71fa1eb46d6f32a2$export$5076a965d1d6464f);
$parcel$export(module.exports, "removeTeamMember", () => $71fa1eb46d6f32a2$export$f7c0e1c7a2575f28);
$parcel$export(module.exports, "getBioAgentModels", () => $71fa1eb46d6f32a2$export$3f6c175549d1e8b0);
$parcel$export(module.exports, "listBioAgentThreads", () => $71fa1eb46d6f32a2$export$7578e4bed71911a);
$parcel$export(module.exports, "getBioAgentThread", () => $71fa1eb46d6f32a2$export$c3a67daaa7910a91);
$parcel$export(module.exports, "deleteBioAgentThread", () => $71fa1eb46d6f32a2$export$9a8e61cfa837cc9d);
$parcel$export(module.exports, "controlBioAgentThread", () => $71fa1eb46d6f32a2$export$a92c6ac22e948132);
$parcel$export(module.exports, "runBioAgentStream", () => $71fa1eb46d6f32a2$export$bd1db4e22ae7cd4c);
$parcel$export(module.exports, "getAnalyticsSummary", () => $71fa1eb46d6f32a2$export$3094806773c8f871);
$parcel$export(module.exports, "getAnalyticsTraffic", () => $71fa1eb46d6f32a2$export$715a470183aa50e);
$parcel$export(module.exports, "getAnalyticsClientInfo", () => $71fa1eb46d6f32a2$export$e7538657864cb525);
$parcel$export(module.exports, "getAnalyticsUsers", () => $71fa1eb46d6f32a2$export$7f371cecaaa2e363);
$parcel$export(module.exports, "addCredits", () => $71fa1eb46d6f32a2$export$85dde3243844605b);
$parcel$export(module.exports, "applyPromo", () => $71fa1eb46d6f32a2$export$a29e3e796008c983);
$parcel$export(module.exports, "loadTxs", () => $71fa1eb46d6f32a2$export$9b9891fb152689ae);
$parcel$export(module.exports, "loadJobs", () => $71fa1eb46d6f32a2$export$e4a65e74801b37b7);
$parcel$export(module.exports, "listJobs", () => $71fa1eb46d6f32a2$export$182e6e22b1a3f4b2);
$parcel$export(module.exports, "listPipelines", () => $71fa1eb46d6f32a2$export$41e30d84a5ef6fe4);
$parcel$export(module.exports, "getPipelineInfo", () => $71fa1eb46d6f32a2$export$25bea889c4c2e9e4);
$parcel$export(module.exports, "listTemplates", () => $71fa1eb46d6f32a2$export$158d803760ae64cb);
$parcel$export(module.exports, "getTemplateInfo", () => $71fa1eb46d6f32a2$export$1cdee53a58be8108);
$parcel$export(module.exports, "saveTemplate", () => $71fa1eb46d6f32a2$export$599702e33c22580b);
$parcel$export(module.exports, "deleteTemplate", () => $71fa1eb46d6f32a2$export$eaca1c6e4717fe30);
$parcel$export(module.exports, "submitPipeline", () => $71fa1eb46d6f32a2$export$f7349cdfacab687b);
$parcel$export(module.exports, "loadJobInfo", () => $71fa1eb46d6f32a2$export$86744d513727828f);
$parcel$export(module.exports, "cancelJob", () => $71fa1eb46d6f32a2$export$204dbeab49814f43);
$parcel$export(module.exports, "rerunJob", () => $71fa1eb46d6f32a2$export$f1135ee49c16b5f3);
$parcel$export(module.exports, "submitJob", () => $71fa1eb46d6f32a2$export$7df3ac43e525a530);
$parcel$export(module.exports, "submitAdvancedJob", () => $71fa1eb46d6f32a2$export$dbef58287c8ca0cf);
$parcel$export(module.exports, "moveJobToProject", () => $71fa1eb46d6f32a2$export$48e99f40031f6a86);
$parcel$export(module.exports, "updateJobMemo", () => $71fa1eb46d6f32a2$export$d6af37720e1bf3d2);
$parcel$export(module.exports, "listProjects", () => $71fa1eb46d6f32a2$export$4afcfbb1824571e4);
$parcel$export(module.exports, "listProjectsPage", () => $71fa1eb46d6f32a2$export$eaba0f8f33c7c846);
$parcel$export(module.exports, "createProject", () => $71fa1eb46d6f32a2$export$fbb34fdd2a7bb43f);
$parcel$export(module.exports, "deleteProject", () => $71fa1eb46d6f32a2$export$d7ff2361273ba2c2);
$parcel$export(module.exports, "renameProject", () => $71fa1eb46d6f32a2$export$3b5b47b5c85af535);
$parcel$export(module.exports, "downloadJobData", () => $71fa1eb46d6f32a2$export$babc80001f753feb);
$parcel$export(module.exports, "downloadDataFile", () => $71fa1eb46d6f32a2$export$24a2320979f94d54);
$parcel$export(module.exports, "mintPresignedDownload", () => $71fa1eb46d6f32a2$export$269d83521e170090);
$parcel$export(module.exports, "listAPIKeys", () => $71fa1eb46d6f32a2$export$2150b21fbe7afd43);
$parcel$export(module.exports, "createAPIKey", () => $71fa1eb46d6f32a2$export$74a06131f8652f1d);
$parcel$export(module.exports, "deleteAPIKey", () => $71fa1eb46d6f32a2$export$fa7139b7e9b5143b);
$parcel$export(module.exports, "listOAuthTokens", () => $71fa1eb46d6f32a2$export$300074283d4dddcb);
$parcel$export(module.exports, "revokeOAuthToken", () => $71fa1eb46d6f32a2$export$176725adcda7bdbd);
$parcel$export(module.exports, "listPrograms", () => $71fa1eb46d6f32a2$export$e72afe6c1671fac6);
$parcel$export(module.exports, "getProgramParams", () => $71fa1eb46d6f32a2$export$3ef1d814b17c5fc0);
$parcel$export(module.exports, "getMetrics", () => $71fa1eb46d6f32a2$export$4c527c96df2f0f53);
$parcel$export(module.exports, "getPricing", () => $71fa1eb46d6f32a2$export$37cbe5038cfc5ded);
$parcel$export(module.exports, "listDatasets", () => $71fa1eb46d6f32a2$export$f63f3d4fe5fbf023);
$parcel$export(module.exports, "getDatasetHistory", () => $71fa1eb46d6f32a2$export$c249eaee1f3195af);
$parcel$export(module.exports, "deleteDataset", () => $71fa1eb46d6f32a2$export$2d8ec1dc7fb5ab7a);
$parcel$export(module.exports, "createDataset", () => $71fa1eb46d6f32a2$export$dc0eaef47cc3157f);
$parcel$export(module.exports, "editDataset", () => $71fa1eb46d6f32a2$export$a92ff647ea93ae9f);
$parcel$export(module.exports, "renameDatasetLineage", () => $71fa1eb46d6f32a2$export$d34673904cfea048);
$parcel$export(module.exports, "downloadDatasetArchive", () => $71fa1eb46d6f32a2$export$a739f7b7263d6e06);
$parcel$export(module.exports, "createDatasetUpload", () => $71fa1eb46d6f32a2$export$c79dd9644cd4b2c8);

var $67bV2 = parcelRequire("67bV2");
const $71fa1eb46d6f32a2$var$apiQueue = [];
let $71fa1eb46d6f32a2$var$isProcessing = false;
let $71fa1eb46d6f32a2$var$projectsCache = null;
let $71fa1eb46d6f32a2$var$projectsCacheAt = 0;
let $71fa1eb46d6f32a2$var$projectsCacheScope = '';
const $71fa1eb46d6f32a2$var$PROJECTS_CACHE_TTL_MS = 300000;
function $71fa1eb46d6f32a2$var$currentProjectsCacheScope() {
    const email = String((0, $67bV2.state).email || '').trim().toLowerCase();
    return `${email}|${(0, $67bV2.state).isOwner ? 'owner' : 'user'}|${(0, $67bV2.impersonationQuery)()}`;
}
function $71fa1eb46d6f32a2$var$clearProjectsCache() {
    $71fa1eb46d6f32a2$var$projectsCache = null;
    $71fa1eb46d6f32a2$var$projectsCacheAt = 0;
    $71fa1eb46d6f32a2$var$projectsCacheScope = '';
}
function $71fa1eb46d6f32a2$export$230adb16b95ac815(url) {
    const qs = (0, $67bV2.impersonationQuery)();
    if (!qs) return url;
    return url.includes('?') ? `${url}&${qs}` : `${url}?${qs}`;
}
function $71fa1eb46d6f32a2$var$triggerDownload(url, filename = '', { target: target = '', rel: rel = '' } = {}) {
    const link = document.createElement('a');
    link.href = url;
    if (filename) link.download = filename;
    if (target) link.target = target;
    if (rel) link.rel = rel;
    document.body.appendChild(link);
    try {
        link.click();
    } catch (err) {
        console.warn('download failed', err);
    }
    document.body.removeChild(link);
}
async function $71fa1eb46d6f32a2$var$processQueue() {
    if ($71fa1eb46d6f32a2$var$isProcessing || $71fa1eb46d6f32a2$var$apiQueue.length === 0) return;
    $71fa1eb46d6f32a2$var$isProcessing = true;
    while($71fa1eb46d6f32a2$var$apiQueue.length > 0){
        const { func: func, resolve: resolve, reject: reject } = $71fa1eb46d6f32a2$var$apiQueue.shift();
        try {
            const result = await func();
            resolve(result);
        } catch (error) {
            console.error('API call failed:', error);
            reject(error);
        }
        // Enforce the wait time between calls
        await new Promise((resolve)=>setTimeout(resolve, (0, $67bV2.state).api_wait_ms));
    }
    $71fa1eb46d6f32a2$var$isProcessing = false;
}
function $71fa1eb46d6f32a2$export$5559a3c24575f35b(func) {
    return new Promise((resolve, reject)=>{
        $71fa1eb46d6f32a2$var$apiQueue.push({
            func: func,
            resolve: resolve,
            reject: reject
        });
        $71fa1eb46d6f32a2$var$processQueue(); // Start processing if not already running
    });
}
function $71fa1eb46d6f32a2$var$runReadApiCall(func) {
    return Promise.resolve().then(func);
}
async function $71fa1eb46d6f32a2$var$readApiData(response, fallbackMessage = 'Request failed', defaultValue = {}) {
    let payload = null;
    try {
        payload = await response.json();
    } catch (_) {
        throw new Error(`Invalid API response (HTTP ${response.status})`);
    }
    if (!response.ok || !payload || !payload.success) {
        const error = new Error(payload && payload.error || `${fallbackMessage} (HTTP ${response.status})`);
        if (payload && payload.data !== undefined) error.data = payload.data;
        throw error;
    }
    return payload.data ?? defaultValue;
}
function $71fa1eb46d6f32a2$var$getApiData(url, fallbackMessage, defaultValue = {}) {
    return $71fa1eb46d6f32a2$var$runReadApiCall(async ()=>{
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return $71fa1eb46d6f32a2$var$readApiData(res, fallbackMessage, defaultValue);
    });
}
async function $71fa1eb46d6f32a2$var$getProtectedApiData(url, fallbackMessage = 'Request failed', defaultValue = {}) {
    const response = await fetch(url, {
        method: 'GET'
    });
    if (response.status === 401) throw new Error('Login required');
    if (response.status === 403) throw new Error('Access denied');
    const payload = await response.json();
    if (!payload.success) throw new Error(payload.error || fallbackMessage);
    return payload.data ?? defaultValue;
}
async function $71fa1eb46d6f32a2$var$postApiData(url, body, fallbackMessage = 'Request failed', defaultValue = {}, { impersonate: impersonate = true } = {}) {
    const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
    let options = {
        method: 'POST'
    };
    if (isFormData) options = {
        method: 'POST',
        body: body
    };
    else if (body !== undefined) options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body || {})
    };
    const res = await fetch(impersonate ? $71fa1eb46d6f32a2$export$230adb16b95ac815(url) : url, options);
    return $71fa1eb46d6f32a2$var$readApiData(res, fallbackMessage, defaultValue);
}
async function $71fa1eb46d6f32a2$export$3669e5bb98eb74e3(digest) {
    if (!digest) throw new Error('digest required');
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/dataset/info?digest=${encodeURIComponent(digest)}`), 'Failed to load dataset');
}
async function $71fa1eb46d6f32a2$export$bcba7e442bab9817(name, project) {
    if (!name) throw new Error('dataset name required');
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/dataset/info?name=${encodeURIComponent(name)}`), 'Failed to load dataset');
}
async function $71fa1eb46d6f32a2$export$36024048467da74c(project) {
    const name = String(project || '').trim();
    if (!name) throw new Error('project required');
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/project/primary-dataset?project=${encodeURIComponent(name)}`), 'Failed to load project files');
}
const $71fa1eb46d6f32a2$var$TEXT_MIME_HINTS = [
    'text/',
    'json',
    'xml',
    'yaml',
    'yml',
    'toml',
    'csv',
    'tsv',
    'html'
];
function $71fa1eb46d6f32a2$var$isMimeTextLike(contentType = '') {
    const lower = String(contentType || '').toLowerCase();
    if (!lower) return false;
    return $71fa1eb46d6f32a2$var$TEXT_MIME_HINTS.some((token)=>lower.includes(token));
}
function $71fa1eb46d6f32a2$var$bufferLooksBinary(buffer) {
    if (!(buffer instanceof ArrayBuffer)) return false;
    const sampleLength = Math.min(buffer.byteLength, 2048);
    if (sampleLength === 0) return false;
    const bytes = new Uint8Array(buffer, 0, sampleLength);
    let controlCount = 0;
    for(let i = 0; i < bytes.length; i += 1){
        const value = bytes[i];
        if (value === 0) return true; // embedded NUL strongly suggests binary
        if (value < 0x20 && value !== 0x09 && value !== 0x0A && value !== 0x0D) {
            controlCount += 1;
            if (controlCount > bytes.length / 6) return true; // too many control chars for plain text
        }
    }
    return false;
}
async function $71fa1eb46d6f32a2$export$a4e344481ab5adfd(digest, path) {
    if (!digest || !path) throw new Error('digest and path required');
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/dataset/file?digest=${encodeURIComponent(digest)}&path=${encodeURIComponent(path)}`);
    return $71fa1eb46d6f32a2$var$fetchApiFile(url, {
        parseLegacyJsonPayload: true
    });
}
async function $71fa1eb46d6f32a2$export$f11896f9fbfa2c1e(jobid) {
    const normalized = (0, $67bV2.normalizeJobID)(jobid);
    if (!(0, $67bV2.isValidJobID)(normalized)) throw new Error('valid job id required');
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/job/view?jobid=${normalized}`), 'Failed to load job info');
}
async function $71fa1eb46d6f32a2$export$5dafc8d63fc6f4f0(jobid) {
    const normalized = (0, $67bV2.normalizeJobID)(jobid);
    if (!(0, $67bV2.isValidJobID)(normalized)) throw new Error('valid job id required');
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/job/results?jobid=${normalized}`), 'Failed to load job results');
}
async function $71fa1eb46d6f32a2$export$9adb42d7c69aad44(jobid, path) {
    const normalized = (0, $67bV2.normalizeJobID)(jobid);
    if (!(0, $67bV2.isValidJobID)(normalized) || !path) throw new Error('job id and path required');
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/job/file?jobid=${normalized}&path=${encodeURIComponent(path)}`);
    return $71fa1eb46d6f32a2$var$fetchApiFile(url);
}
function $71fa1eb46d6f32a2$var$fetchApiFile(url, { parseLegacyJsonPayload: parseLegacyJsonPayload = false } = {}) {
    return $71fa1eb46d6f32a2$var$runReadApiCall(async ()=>{
        const res = await fetch(url, {
            method: 'GET'
        });
        if (!res.ok) {
            let message = `Failed to load file (HTTP ${res.status})`;
            try {
                const errText = await res.text();
                if (errText) try {
                    const errJson = JSON.parse(errText);
                    if (errJson && errJson.error) message = errJson.error;
                } catch (_) {
                    message = errText.trim() || message;
                }
            } catch (_) {
            // ignore body-read failures
            }
            throw new Error(message);
        }
        const headerTag = res.headers.get('X-Subseq-File');
        const contentType = res.headers.get('Content-Type') || '';
        const lenHeader = res.headers.get('Content-Length');
        let declaredSize = lenHeader ? parseInt(lenHeader, 10) : NaN;
        const buffer = await res.arrayBuffer();
        if (!Number.isFinite(declaredSize) || declaredSize < 0) declaredSize = buffer.byteLength;
        const textDecoder = new TextDecoder('utf-8', {
            fatal: false
        });
        if (headerTag === '1') {
            const textLike = $71fa1eb46d6f32a2$var$isMimeTextLike(contentType) || !$71fa1eb46d6f32a2$var$bufferLooksBinary(buffer);
            if (!textLike) return {
                size: declaredSize,
                contentType: contentType,
                binary: true,
                buffer: buffer
            };
            const content = textDecoder.decode(buffer);
            return {
                content: content,
                size: declaredSize,
                contentType: contentType,
                binary: false,
                buffer: buffer
            };
        }
        const looksBinary = $71fa1eb46d6f32a2$var$bufferLooksBinary(buffer);
        if (looksBinary) return {
            size: declaredSize,
            contentType: contentType,
            binary: true,
            buffer: buffer
        };
        const fallbackText = textDecoder.decode(buffer);
        if (parseLegacyJsonPayload) try {
            const parsed = JSON.parse(fallbackText);
            if (parsed && typeof parsed === 'object' && parsed.success && parsed.data) {
                const payload = parsed.data;
                const content = String(payload.content || '');
                const size = Number(payload.size || declaredSize || content.length || 0);
                const type = payload.content_type || contentType || '';
                const binary = !!payload.binary;
                if (!binary) return {
                    content: content,
                    size: size,
                    contentType: type,
                    binary: false,
                    buffer: buffer
                };
                return {
                    size: size,
                    contentType: type,
                    binary: true,
                    buffer: buffer
                };
            }
        } catch (_) {
        // not JSON; treat as plain text content
        }
        return {
            content: fallbackText,
            size: declaredSize || fallbackText.length,
            contentType: contentType,
            binary: false,
            buffer: buffer
        };
    });
}
async function $71fa1eb46d6f32a2$export$2ae73e3d443a8aaa({ digest: digest = '', name: name = '', project: project = '' } = {}) {
    const qs = new URLSearchParams();
    if (digest) qs.set('digest', digest);
    else if (name) {
        qs.set('name', name);
        if (project) qs.set('project', project);
    } else throw new Error('dataset digest or name required');
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/dataset/results?${qs.toString()}`), 'Failed to load dataset results');
}
async function $71fa1eb46d6f32a2$export$9ad920565113bbfa(email, { resend: resend = false } = {}) {
    const cleanEmail = String(email || '').trim().toLowerCase();
    if (!cleanEmail) return false;
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        try {
            const data = await $71fa1eb46d6f32a2$var$postApiData('/api/v1/auth/otp', {
                email: cleanEmail,
                resend: !!resend
            }, 'Error', {
                sent: true
            }, {
                impersonate: false
            });
            (0, $67bV2.state).tempEmail = cleanEmail;
            return data || {
                sent: true
            };
        } catch (error) {
            console.error('Error:', error);
            return false;
        }
    });
}
async function $71fa1eb46d6f32a2$export$dcd88816af569b61(sessionId, txId) {
    if (!sessionId || !txId) return false;
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        (0, $67bV2.state).redUrl = "";
        try {
            const response = await fetch(`/api/v1/payment/verify?session_id=${sessionId}&tx=${txId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const resp = await response.json();
            if (resp.success) {
                (0, $67bV2.state).success = true;
                (0, $67bV2.state).redUrl = resp.data.url; // Assuming `resp.data` contains any useful info (like redirect URL)
            } else {
                (0, $67bV2.state).error = resp.error || 'Payment verification failed';
                console.error('Payment verification failed:', resp.error);
                return false;
            }
        } catch (error) {
            (0, $67bV2.state).success = false;
            (0, $67bV2.state).error = error.message || 'Error verifying payment';
            console.error('Error attempting to verify payment:', error);
            return false;
        }
    });
}
async function $71fa1eb46d6f32a2$export$596d806903d1f59e(otp) {
    if (!otp) return;
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        try {
            const data = await $71fa1eb46d6f32a2$var$postApiData('/api/v1/auth/login', {
                email: (0, $67bV2.state).tempEmail,
                otp: otp,
                type: 'web'
            }, 'Login failed', {}, {
                impersonate: false
            });
            if (!data?.expires_at) return;
            (0, $67bV2.setLoginFlag)(true, data.expires_at);
            $71fa1eb46d6f32a2$var$clearProjectsCache();
            (0, $67bV2.resetPage)();
        } catch (error) {
            console.log('Login failed:', error?.message || error);
        }
    });
}
async function $71fa1eb46d6f32a2$var$fetchAccountInfo(url = '/api/v1/account/info') {
    const response = await fetch(url, {
        method: 'GET'
    });
    if (response.status === 401) return {
        unauthorized: true,
        data: null
    };
    const resp = await response.json();
    if (!resp || !resp.success) throw new Error(resp && resp.error || 'Failed to fetch user info');
    return {
        unauthorized: false,
        data: resp.data || {}
    };
}
async function $71fa1eb46d6f32a2$var$fetchTeamsNow() {
    const response = await fetch('/api/v1/team/list', {
        method: 'GET'
    });
    if (response.status === 401) {
        (0, $67bV2.clearClientAuthState)();
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        const err = new Error('Login required');
        err.unauthorized = true;
        throw err;
    }
    const resp = await response.json();
    if (!resp || !resp.success) throw new Error(resp && resp.error || 'Failed to load teams');
    const teams = resp.data && Array.isArray(resp.data.teams) ? resp.data.teams : [];
    (0, $67bV2.setTeams)(teams);
    return teams;
}
async function $71fa1eb46d6f32a2$export$a0973bcfe11b05c9(silent = false) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        try {
            if ((0, $67bV2.state).isOwner && (0, $67bV2.state).viewAsEmail) {
                (0, $67bV2.setViewAsEmail)('');
                $71fa1eb46d6f32a2$var$clearProjectsCache();
                const info = await $71fa1eb46d6f32a2$var$fetchAccountInfo('/api/v1/account/info');
                if (info.data) {
                    (0, $67bV2.state).email = info.data.email || '';
                    (0, $67bV2.setCredits)(Number(info.data.credits || 0));
                    (0, $67bV2.updateUserDisplay)();
                }
                return true;
            }
            const response = await fetch('/api/v1/account/logout', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            let result = {};
            try {
                result = await response.json();
            } catch (_) {
                result = {};
            }
            if (response.ok && result.success || response.status === 401) {
                (0, $67bV2.clearClientAuthState)();
                $71fa1eb46d6f32a2$var$clearProjectsCache();
                if (!silent) window.location.href = '/';
            } else console.error('Logout failed:', result.error || response.statusText);
        } catch (error) {
            console.error('Error during logout:', error);
        }
    });
}
async function $71fa1eb46d6f32a2$var$loadUserInfoNow() {
    try {
        let baseInfo;
        try {
            baseInfo = await $71fa1eb46d6f32a2$var$fetchAccountInfo($71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/account/info'));
        } catch (infoErr) {
            if (!(0, $67bV2.state).activeTeamId) throw infoErr;
            (0, $67bV2.setActiveTeamId)(0);
            $71fa1eb46d6f32a2$var$clearProjectsCache();
            baseInfo = await $71fa1eb46d6f32a2$var$fetchAccountInfo('/api/v1/account/info');
        }
        if (baseInfo.unauthorized) {
            (0, $67bV2.clearClientAuthState)();
            $71fa1eb46d6f32a2$var$clearProjectsCache();
            return;
        }
        const baseData = baseInfo.data || {};
        (0, $67bV2.state).email = baseData.email || '';
        (0, $67bV2.state).analyticsAccess = false;
        (0, $67bV2.state).isOwner = false;
        try {
            const extraRes = await fetch('/api/v1/account/extra', {
                method: 'GET'
            });
            if (extraRes.ok) {
                const extra = await extraRes.json();
                if (extra && extra.success && extra.data) {
                    (0, $67bV2.state).analyticsAccess = !!extra.data.analytics_access;
                    (0, $67bV2.state).isOwner = !!extra.data.is_owner;
                }
            }
        } catch (extraErr) {
            console.warn('Failed to fetch account extra:', extraErr);
        }
        (0, $67bV2.loadSavedViewAs)();
        try {
            await $71fa1eb46d6f32a2$var$fetchTeamsNow();
        } catch (teamErr) {
            if (teamErr?.unauthorized) return;
            console.warn('Failed to fetch teams:', teamErr);
        }
        if ((0, $67bV2.state).isOwner) window.subseqSetViewAs = async (email)=>{
            (0, $67bV2.setViewAsEmail)(email);
            $71fa1eb46d6f32a2$var$clearProjectsCache();
            await $71fa1eb46d6f32a2$export$20eb8298185fc87b();
        };
        else {
            delete window.subseqSetViewAs;
            (0, $67bV2.state).viewAsEmail = '';
        }
        let effectiveData = baseData;
        if ((0, $67bV2.state).isOwner && (0, $67bV2.state).viewAsEmail) try {
            const impInfo = await $71fa1eb46d6f32a2$var$fetchAccountInfo($71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/account/info'));
            effectiveData = impInfo.data || baseData;
        } catch (impErr) {
            console.warn('Failed to fetch impersonated account info:', impErr);
            (0, $67bV2.setViewAsEmail)('');
        }
        (0, $67bV2.state).email = effectiveData.email || '';
        (0, $67bV2.hydrateProjectFocus)();
        (0, $67bV2.setCredits)(Number(effectiveData.credits || 0));
        (0, $67bV2.updateUserDisplay)();
    } catch (error) {
        console.error('Failed to fetch user info:', error);
        (0, $67bV2.state).analyticsAccess = false;
        (0, $67bV2.state).isOwner = false;
        (0, $67bV2.state).viewAsEmail = '';
    }
}
async function $71fa1eb46d6f32a2$export$20eb8298185fc87b() {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b($71fa1eb46d6f32a2$var$loadUserInfoNow);
}
async function $71fa1eb46d6f32a2$export$79e2c9b6a8cec01c() {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b($71fa1eb46d6f32a2$var$fetchTeamsNow);
}
async function $71fa1eb46d6f32a2$export$dadd67f86cf9b534(name) {
    const clean = String(name || '').trim();
    if (!clean) throw new Error('name required');
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const response = await fetch('/api/v1/team/new', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: clean
            })
        });
        const resp = await response.json();
        if (!resp || !resp.success) throw new Error(resp && resp.error || 'Failed to create team');
        await $71fa1eb46d6f32a2$var$fetchTeamsNow();
        return resp.data || {};
    });
}
async function $71fa1eb46d6f32a2$export$ded43b9f71d30fcf(teamID) {
    const id = Number(teamID || 0);
    if (!id) throw new Error('team_id required');
    return $71fa1eb46d6f32a2$var$getApiData(`/api/v1/team/info?team_id=${encodeURIComponent(String(id))}`, 'Failed to load team');
}
async function $71fa1eb46d6f32a2$export$1bf59bff292a469d(teamID, name) {
    const id = Number(teamID || 0);
    const clean = String(name || '').trim();
    if (!id || !clean) throw new Error('team_id and name required');
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/team/rename', {
            team_id: id,
            name: clean
        }, 'Failed to rename team');
        await $71fa1eb46d6f32a2$var$fetchTeamsNow();
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$1d57c8a8fd4b49d1(teamID, email, isTeamAdmin = false) {
    return $71fa1eb46d6f32a2$var$writeTeamMember('/api/v1/team/member/add', teamID, email, isTeamAdmin);
}
async function $71fa1eb46d6f32a2$export$5076a965d1d6464f(teamID, userID, isTeamAdmin = false) {
    const id = Number(teamID || 0);
    const uid = Number(userID || 0);
    if (!id || !uid) throw new Error('team_id and user_id required');
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/team/member/update', {
            team_id: id,
            user_id: uid,
            is_team_admin: !!isTeamAdmin
        }, 'Failed to update member');
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$f7c0e1c7a2575f28(teamID, userID) {
    const id = Number(teamID || 0);
    const uid = Number(userID || 0);
    if (!id || !uid) throw new Error('team_id and user_id required');
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/team/member/remove', {
            team_id: id,
            user_id: uid
        }, 'Failed to remove member');
        return true;
    });
}
function $71fa1eb46d6f32a2$var$writeTeamMember(url, teamID, email, isTeamAdmin) {
    const id = Number(teamID || 0);
    const cleanEmail = String(email || '').trim().toLowerCase();
    if (!id || !cleanEmail) throw new Error('team_id and email required');
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData(url, {
            team_id: id,
            email: cleanEmail,
            is_team_admin: !!isTeamAdmin
        }, 'Failed to update member');
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$3f6c175549d1e8b0() {
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/bio-agent/models'), 'Failed to load Bio Agent models');
}
async function $71fa1eb46d6f32a2$export$7578e4bed71911a(group = 'all', project = '') {
    const params = new URLSearchParams();
    if (group) params.set('group', String(group));
    if (project) params.set('project', String(project).trim());
    params.set('limit', '80');
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/bio-agent/list?${params.toString()}`), 'Failed to load Bio Agents');
}
async function $71fa1eb46d6f32a2$export$c3a67daaa7910a91(threadId) {
    const id = String(threadId || '').trim();
    if (!id) throw new Error('thread_id required');
    return $71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/bio-agent/view?thread_id=${encodeURIComponent(id)}`), 'Failed to load Bio Agent');
}
async function $71fa1eb46d6f32a2$export$9a8e61cfa837cc9d(threadId) {
    const id = String(threadId || '').trim();
    if (!id) throw new Error('thread_id required');
    return $71fa1eb46d6f32a2$var$postApiData('/api/v1/bio-agent/delete', {
        thread_id: id
    }, 'Failed to delete Bio Agent');
}
async function $71fa1eb46d6f32a2$export$a92c6ac22e948132(threadId, action, message = '') {
    return $71fa1eb46d6f32a2$var$postApiData('/api/v1/bio-agent/control', {
        thread_id: String(threadId || '').trim(),
        action: String(action || '').trim(),
        message: String(message || '')
    }, 'Failed to update Bio Agent');
}
function $71fa1eb46d6f32a2$var$parseSSEEventBlock(block) {
    if (!block) return null;
    const lines = String(block).split('\n');
    let event = 'message';
    const dataLines = [];
    for (const lineRaw of lines){
        const line = String(lineRaw || '');
        if (!line || line.startsWith(':')) continue;
        if (line.startsWith('event:')) {
            event = line.slice(6).trim() || 'message';
            continue;
        }
        if (line.startsWith('data:')) {
            const payload = line.slice(5).replace(/^\s/, '');
            dataLines.push(payload);
        }
    }
    if (!dataLines.length) return null;
    const rawData = dataLines.join('\n');
    let data = rawData;
    try {
        data = JSON.parse(rawData);
    } catch (_) {}
    return {
        event: event,
        data: data
    };
}
async function $71fa1eb46d6f32a2$export$bd1db4e22ae7cd4c({ messages: messages = [], provider: provider = '', project: project = '', viewContext: viewContext = null, threadId: threadId = '', message: message = '', onEvent: onEvent = null } = {}) {
    const safeMessages = Array.isArray(messages) ? messages : [];
    const safeContext = viewContext && typeof viewContext === 'object' && !Array.isArray(viewContext) ? viewContext : null;
    const response = await fetch($71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/bio-agent/chat'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            thread_id: String(threadId || '').trim(),
            message: String(message || '').trim(),
            messages: safeMessages,
            provider: String(provider || '').trim(),
            project: String(project || '').trim(),
            view_context: safeContext,
            stream: true
        })
    });
    if (!response.ok) {
        let msg = `Bio Agent request failed (HTTP ${response.status})`;
        try {
            const payload = await response.json();
            if (payload && payload.error) msg = String(payload.error);
        } catch (_) {}
        throw new Error(msg);
    }
    if (!response.body) throw new Error('Bio Agent endpoint did not return a stream');
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let donePayload = null;
    const emit = (evt)=>{
        if (!evt || typeof onEvent !== 'function') return;
        try {
            onEvent(evt);
        } catch (_) {}
    };
    while(true){
        const { value: value, done: done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, {
            stream: true
        }).replace(/\r\n/g, '\n');
        let boundary = buffer.indexOf('\n\n');
        while(boundary !== -1){
            const block = buffer.slice(0, boundary);
            buffer = buffer.slice(boundary + 2);
            const evt = $71fa1eb46d6f32a2$var$parseSSEEventBlock(block);
            if (evt) {
                emit(evt);
                if (evt.event === 'done') donePayload = evt.data || {};
                else if (evt.event === 'error') {
                    const errMsg = evt.data && typeof evt.data === 'object' && evt.data.message ? String(evt.data.message) : 'Bio Agent stream failed';
                    throw new Error(errMsg);
                }
            }
            boundary = buffer.indexOf('\n\n');
        }
    }
    const tail = decoder.decode();
    if (tail) buffer += tail.replace(/\r\n/g, '\n');
    if (buffer.trim()) {
        const evt = $71fa1eb46d6f32a2$var$parseSSEEventBlock(buffer);
        if (evt) {
            emit(evt);
            if (evt.event === 'done') donePayload = evt.data || {};
            else if (evt.event === 'error') {
                const errMsg = evt.data && typeof evt.data === 'object' && evt.data.message ? String(evt.data.message) : 'Bio Agent stream failed';
                throw new Error(errMsg);
            }
        }
    }
    if (!donePayload || typeof donePayload !== 'object') throw new Error('Bio Agent stream ended before completion');
    return donePayload;
}
async function $71fa1eb46d6f32a2$export$3094806773c8f871(filters = {}) {
    const { start: start, end: end } = filters || {};
    const params = new URLSearchParams();
    if (start) params.set('start', start);
    if (end) params.set('end', end);
    const qs = params.toString();
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(()=>$71fa1eb46d6f32a2$var$getProtectedApiData(`/api/v1/admin/analytics${qs ? `?${qs}` : ''}`, 'Failed to load analytics', {}));
}
function $71fa1eb46d6f32a2$var$analyticsFilterParams(filters = {}, { includeSort: includeSort = false } = {}) {
    const params = new URLSearchParams();
    const { start: start, end: end, userEmail: userEmail, excludeUserEmail: excludeUserEmail, excludeUserEmails: excludeUserEmails, ip: ip, excludeIp: excludeIp } = filters || {};
    if (start) params.set('start', start);
    if (end) params.set('end', end);
    if (userEmail) params.set('user_email', userEmail);
    const excludedEmails = Array.isArray(excludeUserEmails) ? excludeUserEmails : excludeUserEmail ? [
        excludeUserEmail
    ] : [];
    excludedEmails.map((email)=>String(email || '').trim()).filter(Boolean).forEach((email)=>params.append('exclude_user_email', email));
    if (ip) params.set('ip', ip);
    if (excludeIp) params.set('exclude_ip', excludeIp);
    if (includeSort) {
        const { sort: sort, limit: limit } = filters || {};
        if (sort) params.set('sort', sort);
        if (limit) params.set('limit', String(limit));
    }
    return params;
}
async function $71fa1eb46d6f32a2$export$715a470183aa50e(filters = {}) {
    const params = $71fa1eb46d6f32a2$var$analyticsFilterParams(filters);
    const qs = params.toString();
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(()=>$71fa1eb46d6f32a2$var$getProtectedApiData(`/api/v1/admin/analytics/traffic${qs ? `?${qs}` : ''}`, 'Failed to load traffic analytics', {
            buckets: [],
            endpoint_totals: [],
            total_hits: 0
        }));
}
async function $71fa1eb46d6f32a2$export$e7538657864cb525() {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(()=>$71fa1eb46d6f32a2$var$getProtectedApiData('/api/v1/admin/analytics/client', 'Failed to load analytics client info', {}));
}
async function $71fa1eb46d6f32a2$export$7f371cecaaa2e363(filters = {}) {
    const params = $71fa1eb46d6f32a2$var$analyticsFilterParams(filters, {
        includeSort: true
    });
    const qs = params.toString();
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const data = await $71fa1eb46d6f32a2$var$getProtectedApiData(`/api/v1/admin/analytics/users${qs ? `?${qs}` : ''}`, 'Failed to load user activity analytics', []);
        return Array.isArray(data) ? data : [];
    });
}
async function $71fa1eb46d6f32a2$export$85dde3243844605b(amount) {
    if (isNaN(amount) || amount < 1) return;
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        try {
            const response = await fetch($71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/payment/create-checkout'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    credits: amount
                })
            });
            const resp = await response.json();
            if (resp.success && resp.data.url) window.location.href = resp.data.url;
            else console.error('Payment creation failed:', resp.error);
        } catch (error) {
            console.error('Payment error:', error);
        }
    });
}
async function $71fa1eb46d6f32a2$export$a29e3e796008c983(code) {
    const promo = String(code || '').trim();
    if (!promo) throw new Error('Promo code required');
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const response = await fetch($71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/promo/apply'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: promo
            })
        });
        const resp = await response.json();
        if (!resp || !resp.success) throw new Error(resp && resp.error || 'Failed to apply promo');
        return resp.data || {};
    });
}
async function $71fa1eb46d6f32a2$export$9b9891fb152689ae(offset = 0) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        if ((0, $67bV2.state).txsLoading) return;
        (0, $67bV2.state).txsLoading = true;
        try {
            const status = (0, $67bV2.state).txFilter;
            const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/tx/list?limit=${(0, $67bV2.MAX_DATA_ENTRIES)}&offset=${offset}&status=${status}`);
            const data = await $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to fetch transactions', {
                txs: [],
                total: 0
            });
            (0, $67bV2.state).txs = data.txs || [];
            (0, $67bV2.state).totalTxs = data.total || 0;
        } catch (error) {
            console.error('Failed to fetch transactions:', error);
        } finally{
            (0, $67bV2.state).txsLoading = false;
        }
    });
}
async function $71fa1eb46d6f32a2$export$e4a65e74801b37b7(limit = (0, $67bV2.MAX_DATA_ENTRIES), offset = 0, project = '', before = '', program = '', pipeline = '') {
    return $71fa1eb46d6f32a2$var$runReadApiCall(async ()=>{
        if ((0, $67bV2.state).jobsLoading) return;
        (0, $67bV2.state).jobsLoading = true;
        try {
            const programFilter = program || (0, $67bV2.state).jobProgramFilter || '';
            const pipelineFilter = pipeline || (0, $67bV2.state).jobPipelineFilter || '';
            (0, $67bV2.state).jobProgramFilter = programFilter;
            (0, $67bV2.state).jobPipelineFilter = pipelineFilter;
            const data = await $71fa1eb46d6f32a2$export$182e6e22b1a3f4b2(limit, offset, project, (0, $67bV2.state).jobFilter, before, programFilter, pipelineFilter);
            (0, $67bV2.state).totalJobs = data.total || 0;
            (0, $67bV2.state).jobs = (0, $67bV2.state).totalJobs == 0 ? [] : data.jobs || [];
        } catch (error) {
            console.error('Failed to fetch jobs:', error);
        } finally{
            (0, $67bV2.state).jobsLoading = false;
        }
    });
}
async function $71fa1eb46d6f32a2$export$182e6e22b1a3f4b2(limit = 20, offset = 0, project = '', status = 'all', before = '', program = '', pipeline = '') {
    const statusFilter = status || 'all';
    const projQS = project ? `&project=${encodeURIComponent(project)}` : '';
    const beforeQS = before ? `&before=${encodeURIComponent(before)}` : '';
    const programQS = program ? `&program=${encodeURIComponent(program)}` : '';
    const pipelineQS = pipeline ? `&pipeline_id=${encodeURIComponent(pipeline)}&pipeline=${encodeURIComponent(pipeline)}` : '';
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/job/list?limit=${limit}&offset=${offset}&status=${encodeURIComponent(statusFilter)}${projQS}${beforeQS}${programQS}${pipelineQS}`);
    return $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to list jobs', {
        total: 0,
        jobs: []
    });
}
async function $71fa1eb46d6f32a2$export$41e30d84a5ef6fe4(limit = 20, offset = 0, status = 'all', project = '') {
    const statusFilter = status || 'all';
    const statusQS = statusFilter && statusFilter !== 'all' ? `&status=${encodeURIComponent(statusFilter)}` : '';
    const projQS = project ? `&project=${encodeURIComponent(project)}` : '';
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/pipeline/list?limit=${limit}&offset=${offset}${statusQS}${projQS}`);
    return $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to list pipelines', {
        total: 0,
        pipelines: []
    });
}
async function $71fa1eb46d6f32a2$export$25bea889c4c2e9e4(pipelineID) {
    if (!pipelineID) throw new Error('pipeline_id required');
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/pipeline/info?pipeline_id=${encodeURIComponent(pipelineID)}`);
    return $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to load pipeline');
}
async function $71fa1eb46d6f32a2$export$158d803760ae64cb(limit = 20, offset = 0) {
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/template/list?limit=${limit}&offset=${offset}`);
    return $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to list templates', {
        total: 0,
        templates: []
    });
}
async function $71fa1eb46d6f32a2$export$1cdee53a58be8108(templateID) {
    if (!templateID) throw new Error('template_id required');
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/template/info?template_id=${encodeURIComponent(templateID)}`);
    return $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to load template');
}
async function $71fa1eb46d6f32a2$export$599702e33c22580b(payload = {}) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(()=>$71fa1eb46d6f32a2$var$postApiData('/api/v1/template/save', payload || {}, 'Failed to save template'));
}
async function $71fa1eb46d6f32a2$export$eaca1c6e4717fe30(templateID) {
    if (!templateID) throw new Error('template_id required');
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(()=>$71fa1eb46d6f32a2$var$postApiData('/api/v1/template/delete', {
            template_id: templateID
        }, 'Failed to delete template'));
}
async function $71fa1eb46d6f32a2$export$f7349cdfacab687b(payload = {}) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const data = await $71fa1eb46d6f32a2$var$postApiData('/api/v1/pipeline/submit', payload, 'Failed to submit pipeline');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return data;
    });
}
async function $71fa1eb46d6f32a2$export$86744d513727828f(jobID) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const normalized = (0, $67bV2.normalizeJobID)(jobID);
        if (!(0, $67bV2.isValidJobID)(normalized)) {
            console.error("Invalid job ID");
            return;
        }
        if ((0, $67bV2.state).jobInfoLoading) return;
        (0, $67bV2.state).jobInfoLoading = true;
        try {
            (0, $67bV2.state).jobinfo = await $71fa1eb46d6f32a2$export$f11896f9fbfa2c1e(normalized);
            (0, $67bV2.state).success = true;
            (0, $67bV2.state).error = null;
        } catch (error) {
            (0, $67bV2.state).success = false;
            (0, $67bV2.state).error = error.message || "Network error occurred";
            console.error("Failed to fetch job info:", error);
        } finally{
            (0, $67bV2.state).jobInfoLoading = false;
        }
    });
}
async function $71fa1eb46d6f32a2$export$204dbeab49814f43(jobId) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        if ((0, $67bV2.state).jobCanceling) return;
        (0, $67bV2.state).jobCanceling = true;
        try {
            await $71fa1eb46d6f32a2$var$postApiData(`/api/v1/job/cancel?jobid=${jobId}`, undefined, 'Failed to cancel job');
            $71fa1eb46d6f32a2$var$clearProjectsCache();
            return true;
        } catch (error) {
            console.error('Error cancelling job:', error);
            throw error;
        } finally{
            (0, $67bV2.state).jobCanceling = false;
        }
    });
}
async function $71fa1eb46d6f32a2$export$f1135ee49c16b5f3(jobId) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const normalized = (0, $67bV2.normalizeJobID)(jobId);
        if (!(0, $67bV2.isValidJobID)(normalized)) throw new Error('Invalid job ID');
        const data = await $71fa1eb46d6f32a2$var$postApiData('/api/v1/job/rerun', {
            job_id: normalized
        }, 'Failed to rerun job');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return data;
    });
}
function $71fa1eb46d6f32a2$var$submitJobForm(endpoint, formData, { parseError: parseError, logLabel: logLabel }) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        if ((0, $67bV2.state).jobSubmitting) return;
        (0, $67bV2.state).jobSubmitting = true;
        (0, $67bV2.state).success = false;
        (0, $67bV2.state).error = '';
        (0, $67bV2.state).job_id = '';
        try {
            const data = await $71fa1eb46d6f32a2$var$postApiData(endpoint, formData, parseError);
            const jobId = data?.job_id || data?.jobid || '';
            if (!jobId) throw new Error("An unknown error occurred");
            (0, $67bV2.state).job_id = jobId;
            (0, $67bV2.state).success = true;
            (0, $67bV2.state).error = null;
            $71fa1eb46d6f32a2$var$clearProjectsCache();
        } catch (error) {
            (0, $67bV2.state).success = false;
            (0, $67bV2.state).error = error.message || parseError;
            console.error(logLabel, error);
        } finally{
            (0, $67bV2.state).jobSubmitting = false;
        }
    });
}
async function $71fa1eb46d6f32a2$export$7df3ac43e525a530(formData) {
    return $71fa1eb46d6f32a2$var$submitJobForm('/api/v1/job/submit', formData, {
        parseError: 'An error occurred during job submission',
        logLabel: 'Failed to submit job:'
    });
}
async function $71fa1eb46d6f32a2$export$dbef58287c8ca0cf(formData) {
    return $71fa1eb46d6f32a2$var$submitJobForm('/api/v1/job/submit-advanced', formData, {
        parseError: 'An error occurred during advanced job submission',
        logLabel: 'Failed to submit advanced job:'
    });
}
async function $71fa1eb46d6f32a2$export$48e99f40031f6a86(jobId, projectName = '') {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        if (!jobId) throw new Error('jobId required');
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/job/move-project', {
            job_id: jobId,
            project: projectName
        }, 'Failed to move job');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$d6af37720e1bf3d2(jobId, memo = '') {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        if (!jobId) throw new Error('jobId required');
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/job/update-memo', {
            job_id: jobId,
            memo: memo
        }, 'Failed to update memo');
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$4afcfbb1824571e4({ force: force = false } = {}) {
    const now = Date.now();
    const cacheScope = $71fa1eb46d6f32a2$var$currentProjectsCacheScope();
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/project/list?limit=100&offset=0');
    if (!force && $71fa1eb46d6f32a2$var$projectsCache && $71fa1eb46d6f32a2$var$projectsCacheScope === cacheScope && now - $71fa1eb46d6f32a2$var$projectsCacheAt < $71fa1eb46d6f32a2$var$PROJECTS_CACHE_TTL_MS) return $71fa1eb46d6f32a2$var$projectsCache.slice();
    return $71fa1eb46d6f32a2$var$runReadApiCall(async ()=>{
        try {
            const data = await $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to load projects', {
                total: 0,
                projects: []
            });
            $71fa1eb46d6f32a2$var$projectsCache = Array.isArray(data.projects) ? data.projects : [];
            $71fa1eb46d6f32a2$var$projectsCacheAt = Date.now();
            $71fa1eb46d6f32a2$var$projectsCacheScope = cacheScope;
            return $71fa1eb46d6f32a2$var$projectsCache.slice();
        } catch (err) {
            console.error('Failed to load projects:', err);
            throw err;
        }
    });
}
async function $71fa1eb46d6f32a2$export$eaba0f8f33c7c846(limit = 20, offset = 0, q = '') {
    const qs = new URLSearchParams();
    qs.set('limit', String(limit));
    qs.set('offset', String(offset));
    if (q) qs.set('q', q);
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/project/list?${qs.toString()}`);
    return $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to load projects', {
        total: 0,
        projects: []
    });
}
async function $71fa1eb46d6f32a2$export$fbb34fdd2a7bb43f(name) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/project/new', {
            name: name
        }, 'Failed to create project');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$d7ff2361273ba2c2(name) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/project/delete', {
            name: name
        }, 'Failed to delete project');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$3b5b47b5c85af535(name, newName) {
    const cleanName = String(name || '').trim();
    const cleanNewName = String(newName || '').trim();
    if (!cleanName || !cleanNewName) throw new Error('name and new_name required');
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/project/rename', {
            name: cleanName,
            new_name: cleanNewName
        }, 'Failed to rename project');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$babc80001f753feb(jobid, { acceptPartial: acceptPartial = false } = {}) {
    const normalized = (0, $67bV2.normalizeJobID)(jobid);
    if (!(0, $67bV2.isValidJobID)(normalized)) return;
    const qs = new URLSearchParams({
        jobid: normalized
    });
    if (acceptPartial) qs.set('accept_partial_data', 'true');
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/job/download?${qs.toString()}`);
    $71fa1eb46d6f32a2$var$triggerDownload(url, `${normalized}.zip`);
}
function $71fa1eb46d6f32a2$export$24a2320979f94d54({ jobid: jobid = '', digest: digest = '', path: path = '' } = {}) {
    if (!path) return false;
    const qs = new URLSearchParams();
    if (jobid) qs.set('jobid', jobid);
    else if (digest) qs.set('digest', digest);
    else return false;
    qs.set('path', path);
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(jobid ? `/api/v1/job/file?${qs.toString()}` : `/api/v1/dataset/file?${qs.toString()}`);
    $71fa1eb46d6f32a2$var$triggerDownload(url, path.split('/').filter(Boolean).pop() || 'download', {
        rel: 'noopener'
    });
    return true;
}
const $71fa1eb46d6f32a2$var$PRESIGN_TYPES = [
    'job_download',
    'job_file',
    'dataset_download',
    'dataset_file'
];
const $71fa1eb46d6f32a2$var$MAX_PRESIGN_TTL_SECONDS = 259200; // 3 days; UI enforces the same cap
async function $71fa1eb46d6f32a2$export$269d83521e170090(opts = {}) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const { type: type } = opts || {};
        if (!type || !$71fa1eb46d6f32a2$var$PRESIGN_TYPES.includes(type)) throw new Error('invalid presign type');
        let ttlSeconds = Number(opts.ttl_seconds || opts.ttlSeconds || 0);
        if (!Number.isFinite(ttlSeconds) || ttlSeconds <= 0) ttlSeconds = 3600;
        if (ttlSeconds > $71fa1eb46d6f32a2$var$MAX_PRESIGN_TTL_SECONDS) ttlSeconds = $71fa1eb46d6f32a2$var$MAX_PRESIGN_TTL_SECONDS;
        const body = {
            type: type,
            jobid: opts.jobid || opts.jobId || '',
            digest: opts.digest || '',
            name: opts.name || '',
            project: opts.project || '',
            path: opts.path || '',
            accept_partial_data: !!opts.accept_partial_data,
            ttl_seconds: Math.round(ttlSeconds)
        };
        if ((0, $67bV2.state).isOwner && (0, $67bV2.state).viewAsEmail) body.user_email = (0, $67bV2.state).viewAsEmail;
        return $71fa1eb46d6f32a2$var$postApiData('/api/v1/download/presign', body, 'Failed to mint URL');
    });
}
async function $71fa1eb46d6f32a2$export$2150b21fbe7afd43() {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(()=>$71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/key/list'), 'Failed to load API keys', []));
}
async function $71fa1eb46d6f32a2$export$74a06131f8652f1d({ label: label = '', expiresInDays: expiresInDays = 0, access: access = 'read/write', project: project = '' } = {}) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const data = await $71fa1eb46d6f32a2$var$postApiData('/api/v1/key/new', {
            label: label,
            expires_in_days: expiresInDays,
            access: access,
            project: project
        }, 'Failed to create API key');
        if (data && data.key) return data.key; // plaintext key (shown once)
        throw new Error('Failed to create API key');
    });
}
async function $71fa1eb46d6f32a2$export$fa7139b7e9b5143b(keyHash) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/key/delete', {
            key_hash: keyHash
        }, 'Failed to delete API key');
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$300074283d4dddcb() {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(()=>$71fa1eb46d6f32a2$var$getApiData($71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/oauth/token/list'), 'Failed to load OAuth tokens', []));
}
async function $71fa1eb46d6f32a2$export$176725adcda7bdbd(tokenHash) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/oauth/token/revoke', {
            token_hash: tokenHash
        }, 'Failed to revoke OAuth token');
        return true;
    });
}
// -------- Programs --------
// Simple in-memory cache to keep UI snappy across pages
let $71fa1eb46d6f32a2$var$_programsCache = null;
let $71fa1eb46d6f32a2$var$_programsCacheAt = 0;
const $71fa1eb46d6f32a2$var$_PROGRAMS_TTL_MS = 300000; // 5 minutes
async function $71fa1eb46d6f32a2$export$e72afe6c1671fac6({ force: force = false } = {}) {
    const now = Date.now();
    if (!force && $71fa1eb46d6f32a2$var$_programsCache && now - $71fa1eb46d6f32a2$var$_programsCacheAt < $71fa1eb46d6f32a2$var$_PROGRAMS_TTL_MS) return $71fa1eb46d6f32a2$var$_programsCache;
    const data = await $71fa1eb46d6f32a2$var$getApiData('/api/v1/program/list', 'Failed to list programs', []);
    const list = Array.isArray(data) ? data : [];
    $71fa1eb46d6f32a2$var$_programsCache = list;
    $71fa1eb46d6f32a2$var$_programsCacheAt = Date.now();
    return list;
}
const $71fa1eb46d6f32a2$var$_programParamsCache = new Map();
const $71fa1eb46d6f32a2$var$_programParamsPending = new Map();
async function $71fa1eb46d6f32a2$export$3ef1d814b17c5fc0(program, { force: force = false } = {}) {
    const name = String(program || '').trim();
    if (!name) throw new Error('program required');
    if (!force && $71fa1eb46d6f32a2$var$_programParamsCache.has(name)) return $71fa1eb46d6f32a2$var$_programParamsCache.get(name);
    if (!force && $71fa1eb46d6f32a2$var$_programParamsPending.has(name)) return $71fa1eb46d6f32a2$var$_programParamsPending.get(name);
    const request = $71fa1eb46d6f32a2$var$getApiData(`/api/v1/program/params?program=${encodeURIComponent(name)}`, 'Failed to load program params').then((payload)=>{
        $71fa1eb46d6f32a2$var$_programParamsCache.set(name, payload);
        return payload;
    }).finally(()=>{
        $71fa1eb46d6f32a2$var$_programParamsPending.delete(name);
    });
    if (!force) $71fa1eb46d6f32a2$var$_programParamsPending.set(name, request);
    return request;
}
const $71fa1eb46d6f32a2$var$_metricsCache = new Map();
const $71fa1eb46d6f32a2$var$_metricsPending = new Map();
const $71fa1eb46d6f32a2$var$_METRICS_TTL_MS = 300000;
async function $71fa1eb46d6f32a2$export$4c527c96df2f0f53({ program: program = '', params: params = null, force: force = false } = {}) {
    const name = String(program || '').trim().toLowerCase();
    const paramsJSON = params && typeof params === 'object' ? JSON.stringify(params) : '';
    const key = `${name || '__all__'}:${paramsJSON}`;
    const now = Date.now();
    const cached = $71fa1eb46d6f32a2$var$_metricsCache.get(key);
    if (!force && cached && now - cached.at < $71fa1eb46d6f32a2$var$_METRICS_TTL_MS) return cached.value;
    if (!force && $71fa1eb46d6f32a2$var$_metricsPending.has(key)) return $71fa1eb46d6f32a2$var$_metricsPending.get(key);
    const query = new URLSearchParams();
    if (name) query.set('program', name);
    if (paramsJSON) query.set('params', paramsJSON);
    const suffix = query.toString() ? `?${query.toString()}` : '';
    const request = $71fa1eb46d6f32a2$var$getApiData(`/api/v1/metrics${suffix}`, 'Failed to load metrics', []).then((payload)=>{
        const list = Array.isArray(payload) ? payload : [];
        $71fa1eb46d6f32a2$var$_metricsCache.set(key, {
            value: list,
            at: Date.now()
        });
        return list;
    }).finally(()=>{
        $71fa1eb46d6f32a2$var$_metricsPending.delete(key);
    });
    if (!force) $71fa1eb46d6f32a2$var$_metricsPending.set(key, request);
    return request;
}
// Global pricing
let $71fa1eb46d6f32a2$var$_pricingCache = null;
let $71fa1eb46d6f32a2$var$_pricingCacheAt = 0;
const $71fa1eb46d6f32a2$var$_PRICING_TTL_MS = 300000;
async function $71fa1eb46d6f32a2$export$37cbe5038cfc5ded({ force: force = false } = {}) {
    const now = Date.now();
    if (!force && $71fa1eb46d6f32a2$var$_pricingCache && now - $71fa1eb46d6f32a2$var$_pricingCacheAt < $71fa1eb46d6f32a2$var$_PRICING_TTL_MS) return $71fa1eb46d6f32a2$var$_pricingCache;
    $71fa1eb46d6f32a2$var$_pricingCache = await $71fa1eb46d6f32a2$var$getApiData('/api/v1/pricing', 'Failed to load pricing', {
        submit_fee: 0
    });
    $71fa1eb46d6f32a2$var$_pricingCacheAt = Date.now();
    return $71fa1eb46d6f32a2$var$_pricingCache;
}
async function $71fa1eb46d6f32a2$export$f63f3d4fe5fbf023(limit = 20, offset = 0, project = '') {
    const projQS = project ? `&project=${encodeURIComponent(project)}` : '';
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/dataset/list?limit=${limit}&offset=${offset}${projQS}`);
    return $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to list datasets', {
        total: 0,
        datasets: []
    });
}
async function $71fa1eb46d6f32a2$export$c249eaee1f3195af(name, project = '', limit = 200, offset = 0) {
    const n = String(name || '').trim();
    if (!n) throw new Error('name required');
    const projQS = project ? `&project=${encodeURIComponent(project)}` : '';
    const url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/dataset/history?name=${encodeURIComponent(n)}&limit=${limit}&offset=${offset}${projQS}`);
    return $71fa1eb46d6f32a2$var$getApiData(url, 'Failed to load dataset history', {
        total: 0,
        datasets: []
    });
}
async function $71fa1eb46d6f32a2$export$2d8ec1dc7fb5ab7a(digest) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        if (!digest) throw new Error('digest required');
        await $71fa1eb46d6f32a2$var$postApiData(`/api/v1/dataset/delete?digest=${encodeURIComponent(digest)}`, undefined, 'Failed to delete dataset');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$dc0eaef47cc3157f(formData) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const data = await $71fa1eb46d6f32a2$var$postApiData('/api/v1/dataset/new', formData, 'Failed to create dataset');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return data;
    });
}
async function $71fa1eb46d6f32a2$export$a92ff647ea93ae9f(formData) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const data = await $71fa1eb46d6f32a2$var$postApiData('/api/v1/dataset/edit', formData, 'Failed to edit dataset');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return data;
    });
}
async function $71fa1eb46d6f32a2$export$fe8f78ce886e498f(digest, projectName = '') {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        if (!digest) throw new Error('digest required');
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/dataset/move-project', {
            digest: digest,
            project: projectName
        }, 'Failed to move dataset');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$d34673904cfea048(name, newName) {
    return $71fa1eb46d6f32a2$export$5559a3c24575f35b(async ()=>{
        const source = String(name || '').trim();
        const target = String(newName || '').trim();
        if (!source || !target) throw new Error('name and new name required');
        await $71fa1eb46d6f32a2$var$postApiData('/api/v1/dataset/rename', {
            name: source,
            new_name: target
        }, 'Failed to rename dataset');
        $71fa1eb46d6f32a2$var$clearProjectsCache();
        return true;
    });
}
async function $71fa1eb46d6f32a2$export$a739f7b7263d6e06({ digest: digest, name: name, project: project } = {}) {
    try {
        let url = '';
        if (digest) url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/dataset/download?digest=${encodeURIComponent(digest)}`);
        else if (name) url = $71fa1eb46d6f32a2$export$230adb16b95ac815(`/api/v1/dataset/download?name=${encodeURIComponent(name)}`);
        else throw new Error('dataset identifier required');
        const fnameId = digest || name || 'dataset';
        $71fa1eb46d6f32a2$var$triggerDownload(url, `dataset_${fnameId}.zip`, {
            target: '_self'
        });
        // No fallback navigation to avoid unexpected redirects/rate-limit hits
        return true;
    } catch (err) {
        throw err;
    }
}
function $71fa1eb46d6f32a2$export$c79dd9644cd4b2c8(formData, onProgress) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', $71fa1eb46d6f32a2$export$230adb16b95ac815('/api/v1/dataset/new'));
    xhr.withCredentials = true; // include cookies/session
    const promise = new Promise((resolve, reject)=>{
        try {
            xhr.upload.onprogress = (e)=>{
                if (typeof onProgress === 'function') {
                    const loaded = e.loaded || 0;
                    const total = e.lengthComputable ? e.total : formData && formData.getAll ? formData.getAll('folder').reduce((acc, f)=>acc + (f?.size || 0), 0) : 0;
                    const percent = total > 0 ? Math.min(100, Math.round(loaded / total * 100)) : 0;
                    try {
                        onProgress({
                            loaded: loaded,
                            total: total,
                            percent: percent
                        });
                    } catch  {}
                }
            };
            xhr.onerror = ()=>{
                const e = new Error('Network error during dataset upload');
                reject(e);
            };
            xhr.onabort = ()=>{
                const e = new Error('Upload canceled');
                e.canceled = true;
                reject(e);
            };
            xhr.onload = ()=>{
                try {
                    const status = xhr.status;
                    const ct = xhr.getResponseHeader('Content-Type') || '';
                    let data = {};
                    if (ct.includes('application/json')) data = JSON.parse(xhr.responseText || '{}');
                    else if ((xhr.responseText || '').trim().startsWith('{')) data = JSON.parse(xhr.responseText || '{}');
                    if (status >= 200 && status < 300 && data && data.success) {
                        $71fa1eb46d6f32a2$var$clearProjectsCache();
                        resolve(data.data || {});
                    } else {
                        const err = new Error(data && data.error || `Upload failed (${status})`);
                        if (data && data.data) err.data = data.data;
                        reject(err);
                    }
                } catch (e) {
                    reject(new Error('Invalid server response'));
                }
            };
            xhr.send(formData);
        } catch (err) {
            reject(err);
        }
    });
    return {
        promise: promise,
        cancel: ()=>{
            try {
                xhr.abort();
            } catch  {}
        }
    };
}

});

parcelRegister("irHXR", function(module, exports) {
let $d6dcda04d4894a56$var$active = null;
let $d6dcda04d4894a56$var$picker = null;
let $d6dcda04d4894a56$var$pickerSeq = 0;
const $d6dcda04d4894a56$var$eligible = (el)=>el instanceof HTMLSelectElement && !el.disabled && !el.multiple && el.size <= 1;
const $d6dcda04d4894a56$var$selectFrom = (target)=>target instanceof Element ? target.closest('select') : null;
function $d6dcda04d4894a56$var$closePicker(refocus = false) {
    const select = $d6dcda04d4894a56$var$active;
    $d6dcda04d4894a56$var$picker?.remove();
    $d6dcda04d4894a56$var$picker = null;
    $d6dcda04d4894a56$var$active = null;
    if (!select) return;
    select.setAttribute('aria-expanded', 'false');
    select.removeAttribute('aria-controls');
    if (refocus && select.isConnected) select.focus({
        preventScroll: true
    });
}
function $d6dcda04d4894a56$var$positionPicker() {
    if (!$d6dcda04d4894a56$var$active || !$d6dcda04d4894a56$var$picker) return;
    const rect = $d6dcda04d4894a56$var$active.getBoundingClientRect();
    const pad = 8;
    const gap = 4;
    const below = window.innerHeight - rect.bottom - gap - pad;
    const above = rect.top - gap - pad;
    const showBelow = below >= Math.min(240, $d6dcda04d4894a56$var$picker.scrollHeight) || below >= above;
    const room = Math.max(64, showBelow ? below : above);
    $d6dcda04d4894a56$var$picker.style.minWidth = `${Math.ceil(rect.width)}px`;
    $d6dcda04d4894a56$var$picker.style.maxHeight = `${Math.min(352, room)}px`;
    const left = Math.min(Math.max(pad, rect.left), Math.max(pad, window.innerWidth - $d6dcda04d4894a56$var$picker.offsetWidth - pad));
    const height = Math.min($d6dcda04d4894a56$var$picker.scrollHeight, 352, room);
    $d6dcda04d4894a56$var$picker.style.left = `${Math.round(left)}px`;
    $d6dcda04d4894a56$var$picker.style.top = `${Math.round(showBelow ? rect.bottom + gap : Math.max(pad, rect.top - gap - height))}px`;
}
function $d6dcda04d4894a56$var$choose(index) {
    if (!$d6dcda04d4894a56$var$active) return;
    const select = $d6dcda04d4894a56$var$active;
    const option = select.options[index];
    if (!option || option.disabled || option.parentElement?.disabled) return;
    const changed = select.selectedIndex !== index;
    select.selectedIndex = index;
    $d6dcda04d4894a56$var$closePicker(true);
    if (!changed) return;
    select.dispatchEvent(new Event('input', {
        bubbles: true
    }));
    select.dispatchEvent(new Event('change', {
        bubbles: true
    }));
}
function $d6dcda04d4894a56$var$addOption(option) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `themed-select-picker-option${option.selected ? ' selected' : ''}`;
    button.textContent = option.textContent.trim();
    button.dataset.index = String(option.index);
    button.setAttribute('role', 'option');
    button.setAttribute('aria-selected', option.selected ? 'true' : 'false');
    button.disabled = option.disabled || !!option.parentElement?.disabled;
    $d6dcda04d4894a56$var$picker.appendChild(button);
}
function $d6dcda04d4894a56$var$openPicker(select) {
    if (!$d6dcda04d4894a56$var$eligible(select)) return;
    if ($d6dcda04d4894a56$var$active === select && $d6dcda04d4894a56$var$picker) return;
    $d6dcda04d4894a56$var$closePicker();
    $d6dcda04d4894a56$var$active = select;
    $d6dcda04d4894a56$var$picker = document.createElement('div');
    $d6dcda04d4894a56$var$picker.id = `themed-select-picker-${++$d6dcda04d4894a56$var$pickerSeq}`;
    $d6dcda04d4894a56$var$picker.className = 'themed-select-picker';
    $d6dcda04d4894a56$var$picker.setAttribute('role', 'listbox');
    $d6dcda04d4894a56$var$picker.setAttribute('aria-label', select.getAttribute('aria-label') || select.labels?.[0]?.textContent.trim() || select.name || 'Options');
    select.setAttribute('aria-haspopup', 'listbox');
    select.setAttribute('aria-expanded', 'true');
    select.setAttribute('aria-controls', $d6dcda04d4894a56$var$picker.id);
    Array.from(select.children).forEach((child)=>{
        if (child instanceof HTMLOptGroupElement) {
            const label = document.createElement('div');
            label.className = 'themed-select-picker-group';
            label.textContent = child.label;
            $d6dcda04d4894a56$var$picker.appendChild(label);
            Array.from(child.children).forEach((option)=>$d6dcda04d4894a56$var$addOption(option));
        } else if (child instanceof HTMLOptionElement) $d6dcda04d4894a56$var$addOption(child);
    });
    $d6dcda04d4894a56$var$picker.addEventListener('click', (event)=>{
        const button = event.target.closest('.themed-select-picker-option');
        if (button && !button.disabled) $d6dcda04d4894a56$var$choose(Number(button.dataset.index));
    });
    document.body.appendChild($d6dcda04d4894a56$var$picker);
    $d6dcda04d4894a56$var$positionPicker();
    requestAnimationFrame(()=>{
        if (!$d6dcda04d4894a56$var$picker) return;
        const selected = $d6dcda04d4894a56$var$picker.querySelector('.themed-select-picker-option.selected:not(:disabled)');
        (selected || $d6dcda04d4894a56$var$picker.querySelector('.themed-select-picker-option:not(:disabled)') || $d6dcda04d4894a56$var$picker).focus({
            preventScroll: true
        });
    });
}
document.addEventListener('pointerdown', (event)=>{
    const select = $d6dcda04d4894a56$var$selectFrom(event.target);
    if ($d6dcda04d4894a56$var$eligible(select) && event.button === 0) {
        event.preventDefault();
        select.focus({
            preventScroll: true
        });
        $d6dcda04d4894a56$var$openPicker(select);
        return;
    }
    if ($d6dcda04d4894a56$var$picker && !$d6dcda04d4894a56$var$picker.contains(event.target)) $d6dcda04d4894a56$var$closePicker();
}, true);
document.addEventListener('mousedown', (event)=>{
    if ($d6dcda04d4894a56$var$eligible($d6dcda04d4894a56$var$selectFrom(event.target)) && event.button === 0) event.preventDefault();
}, true);
document.addEventListener('click', (event)=>{
    const select = $d6dcda04d4894a56$var$selectFrom(event.target);
    if (!$d6dcda04d4894a56$var$eligible(select)) return;
    event.preventDefault();
    $d6dcda04d4894a56$var$openPicker(select);
}, true);
document.addEventListener('keydown', (event)=>{
    const select = $d6dcda04d4894a56$var$selectFrom(event.target);
    if ($d6dcda04d4894a56$var$eligible(select) && [
        'Enter',
        ' ',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key)) {
        event.preventDefault();
        $d6dcda04d4894a56$var$openPicker(select);
        return;
    }
    if (!$d6dcda04d4894a56$var$picker || !$d6dcda04d4894a56$var$picker.contains(event.target)) {
        if (event.key === 'Escape') $d6dcda04d4894a56$var$closePicker();
        return;
    }
    const buttons = Array.from($d6dcda04d4894a56$var$picker.querySelectorAll('.themed-select-picker-option:not(:disabled)'));
    const index = buttons.indexOf(document.activeElement);
    let next = -1;
    if (event.key === 'ArrowDown') next = Math.min(buttons.length - 1, index + 1);
    if (event.key === 'ArrowUp') next = Math.max(0, index - 1);
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = buttons.length - 1;
    if (next >= 0) {
        event.preventDefault();
        buttons[next]?.focus({
            preventScroll: true
        });
    } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        document.activeElement?.click();
    } else if (event.key === 'Escape') {
        event.preventDefault();
        $d6dcda04d4894a56$var$closePicker(true);
    } else if (event.key === 'Tab') $d6dcda04d4894a56$var$closePicker();
    else if (event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) {
        const start = Math.max(0, index + 1);
        const ordered = buttons.slice(start).concat(buttons.slice(0, start));
        const match = ordered.find((button)=>button.textContent.trim().toLowerCase().startsWith(event.key.toLowerCase()));
        if (match) {
            event.preventDefault();
            match.focus({
                preventScroll: true
            });
        }
    }
}, true);
document.addEventListener('change', (event)=>{
    if (event.target === $d6dcda04d4894a56$var$active) $d6dcda04d4894a56$var$closePicker();
}, true);
window.addEventListener('resize', ()=>$d6dcda04d4894a56$var$closePicker());
window.addEventListener('blur', ()=>$d6dcda04d4894a56$var$closePicker());
window.addEventListener('scroll', (event)=>{
    if ($d6dcda04d4894a56$var$picker && !$d6dcda04d4894a56$var$picker.contains(event.target)) $d6dcda04d4894a56$var$closePicker();
}, true);

});


//# sourceMappingURL=websrc.5a50b6c9.js.map
